import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const CarIntro = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_car_intro" />
				<h3 className="intro-tit mt_20">차량번호만 입력하면<br />필요한 정보를 한눈에!</h3>
				<ul className={styles["data-intro-list"]}>
					<li>자동차정보와 시세, 사고이력 등<br />필요한 정보를 쉽게 확인 할 수 있어요!</li>
					<li className="mt_20">자동차 정보, 사고이력은<br />월 2회 무료로 조회가 가능해요!</li>
				</ul>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big">차량 검색하기</Button>
			</div>
		</div>
	)
}

export default CarIntro
